import BookIcon from "@mui/icons-material/BookRounded";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenterRounded";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonthRounded";
import ContentCut from "@mui/icons-material/ContentCutRounded";
import DescriptionIcon from "@mui/icons-material/DescriptionRounded";
import InboxIcon from "@mui/icons-material/InboxRounded";
import LabelImportantIcon from "@mui/icons-material/LabelImportantRounded";
import LabelIcon from "@mui/icons-material/LabelRounded";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooksRounded";
import AnnualMeetingsNoticesIcon from "../icons/AnnualMeetingsNoticesIcon";
import AnnualQuarterlyReportsIcon from "../icons/AnnualQuarterlyReportsIcon";
import ArticlePersonIcon from "../icons/ArticlePersonIcon";
import CapCallNoticeIcon from "../icons/CapCallNoticeIcon";
import CapitalAccountStatementIcon from "../icons/CapitalAccountStatementIcon";
import DistributionNoticeIcon from "../icons/DistributionNoticeIcon";
import FinancialStatementIcon from "../icons/FinancialStatementIcon";
import GeneralIcon from "../icons/GeneralIcon";
import MoneyIcon from "../icons/MoneyIcon";
import QuarterlyCapitalStatementsIcon from "../icons/QuarterlyCapitalStatementsIcon";
import QuarterlyNewsIcon from "../icons/QuarterlyNewsIcon";
import TaxInformationIcon from "../icons/TaxInformationIcon";
import { categoryIcons, materialIconPrefix } from "./categoryIcons";

interface Props {
  iconName: string;
  color?: "inherit" | "action" | "disabled" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

export const DynamicIcon = (props: Props) => {
  const { iconName, color } = props;

  switch (iconName) {
    case "ICON_LEGAL":
      return (
        <BookIcon color={color}>
          <ContentCut />
        </BookIcon>
      );
    case "ICON_NOTICE":
      return (
        <CapCallNoticeIcon color={color}>
          <ContentCut />
        </CapCallNoticeIcon>
      );
    case "ICON_REPORT":
      return (
        <FinancialStatementIcon color={color}>
          <ContentCut />
        </FinancialStatementIcon>
      );
    case "ICON_TAX":
      return (
        <TaxInformationIcon color={color}>
          <ContentCut />
        </TaxInformationIcon>
      );
    case "Inbox":
      return (
        <InboxIcon color={color}>
          <ContentCut />
        </InboxIcon>
      );
    case "Important":
      return (
        <LabelImportantIcon style={{ color: "rgba(255, 180, 0, 1)" }}>
          <ContentCut />
        </LabelImportantIcon>
      );
    case "ICON_DISTRIBUTION_NOTICE":
      return (
        <DistributionNoticeIcon color={color}>
          <ContentCut />
        </DistributionNoticeIcon>
      );
    case "ICON_MONEY":
      return (
        <MoneyIcon color={color}>
          <ContentCut />
        </MoneyIcon>
      );
    case "ICON_OTHER":
      return (
        <DescriptionIcon color={color}>
          <ContentCut />
        </DescriptionIcon>
      );
    case "ICON_BOOKS":
      return (
        <LibraryBooksIcon color={color}>
          <ContentCut />
        </LibraryBooksIcon>
      );
    case "ICON_PCAPS":
      return (
        <CapitalAccountStatementIcon color={color}>
          <ContentCut />
        </CapitalAccountStatementIcon>
      );
    case "ICON_GENERAL":
      return (
        <GeneralIcon color={color}>
          <ContentCut />
        </GeneralIcon>
      );
    case "ICON_QUARTERLY_NEWS":
      return (
        <QuarterlyNewsIcon color={color}>
          <ContentCut />
        </QuarterlyNewsIcon>
      );
    case "ICON_QUARTERLY_CAPITAL_STATEMENTS":
      return (
        <QuarterlyCapitalStatementsIcon color={color}>
          <ContentCut />
        </QuarterlyCapitalStatementsIcon>
      );
    case "ICON_ANNUAL_QUARTERLY_REPORTS":
      return (
        <AnnualQuarterlyReportsIcon color={color}>
          <ContentCut />
        </AnnualQuarterlyReportsIcon>
      );
    case "ICON_ANNUAL_MEETING_NOTICES":
      return (
        <AnnualMeetingsNoticesIcon color={color}>
          <ContentCut />
        </AnnualMeetingsNoticesIcon>
      );
    case "ICON_CALENDAR":
      return (
        <CalendarMonthIcon color={color}>
          <ContentCut />
        </CalendarMonthIcon>
      );
    case "ICON_ACQUISITION":
      return (
        <BusinessCenterIcon color={color}>
          <ContentCut />
        </BusinessCenterIcon>
      );
    case "ICON_LP":
      return (
        <ArticlePersonIcon color={color}>
          <ContentCut />
        </ArticlePersonIcon>
      );
    default: {
      const MaterialIcon = iconName.startsWith(materialIconPrefix)
        ? categoryIcons[iconName.slice(materialIconPrefix.length)]
        : undefined;

      if (MaterialIcon) {
        return <MaterialIcon color={color} />;
      }

      return (
        <LabelIcon color={color}>
          <ContentCut />
        </LabelIcon>
      );
    }
  }
};

export default DynamicIcon;
